import { Controller } from "stimulus";

// The select-all box and the submit button of the copy-regulatory-code modal.
// Articles that already carry the code are rendered disabled, so they are never
// counted here — "select all" means every article that can still receive it.
//
// The state is recomputed when the modal opens, not only on connect. Chrome
// restores checkbox state across a reload without firing a change event, so a
// box can come back ticked while the controller still believes nothing is
// selected — which left the Copy button disabled over a visibly ticked list.
// Bootstrap's shown event is a jQuery event, so it is bound with jQuery: a
// jQuery-triggered event never reaches a native addEventListener.
export default class extends Controller {
  static targets = ["all", "article", "submit", "count"];

  connect() {
    this.refresh();

    this.modal = this.element.closest(".modal");
    if (!this.modal) return;

    this.onShown = () => this.refresh();
    $(this.modal).on("shown.bs.modal", this.onShown);
  }

  disconnect() {
    if (this.modal) $(this.modal).off("shown.bs.modal", this.onShown);
  }

  toggleAll() {
    this.selectable.forEach((box) => {
      box.checked = this.allTarget.checked;
    });
    this.refresh();
  }

  refresh() {
    const chosen = this.selectable.filter((box) => box.checked).length;

    if (this.hasAllTarget) {
      this.allTarget.checked = chosen > 0 && chosen === this.selectable.length;
      this.allTarget.indeterminate = chosen > 0 && chosen < this.selectable.length;
    }

    if (this.hasSubmitTarget) this.submitTarget.disabled = chosen === 0;
    if (this.hasCountTarget) {
      this.countTarget.textContent = chosen === 0 ? "" : `${chosen} selected`;
    }
  }

  get selectable() {
    return this.articleTargets.filter((box) => !box.disabled);
  }
}
